export default {"src":"/_next/static/media/ChooseIocn3.33a0d648.svg","height":56,"width":51};